import React from "react";
import BridalGalleryOn from "../BridalGalleryOn";
import PartyMakeup from "../PartyMakeup";
import EditorialGallery from "../EditorialGallery";
import Group295 from "../Group295";
import ViewMoreGallery from "../ViewMoreGallery";
import BridalGallery from "../BridalGallery";
import PartyGalleryOn from "../PartyGalleryOn";
import Group296 from "../Group296";
import BeroreAfterGalleryOn from "../BeroreAfterGalleryOn";
import BridalMakeup from "../BridalMakeup";
import EditorialGalleryOn from "../EditorialGalleryOn";
import "./Property1Frame293.css";

function Property1Frame293(props) {
  const {
    bridalGalleryOnProps,
    partyMakeup1Props,
    partyMakeup2Props,
    partyGalleryOnProps,
    partyMakeup3Props,
    bridalGallery1Props,
    partyMakeup4Props,
    beroreAfterGalleryOnProps,
    editorialGalleryProps,
    bridalGallery2Props,
    partyMakeup5Props,
    bridalMakeupProps,
    editorialGalleryOnProps,
    viewMoreGalleryProps,
  } = props;

  return (
    <div className="gallery-3">
      <div className="group-303">
        <div className="group">
          <BridalGalleryOn>{bridalGalleryOnProps.children}</BridalGalleryOn>
          <PartyMakeup className={partyMakeup1Props.className}>{partyMakeup1Props.children}</PartyMakeup>
          <PartyMakeup className={partyMakeup2Props.className}>{partyMakeup2Props.children}</PartyMakeup>
          <EditorialGallery />
        </div>
        <Group295 />
        <ViewMoreGallery />
      </div>
      <div className="group-304">
        <div className="group">
          <BridalGallery />
          <PartyGalleryOn>{partyGalleryOnProps.children}</PartyGalleryOn>
          <PartyMakeup className={partyMakeup3Props.className}>{partyMakeup3Props.children}</PartyMakeup>
          <EditorialGallery />
        </div>
        <Group296 />
        <ViewMoreGallery />
      </div>
      <div className="group-305">
        <div className="group">
          <BridalGallery className={bridalGallery1Props.className} />
          <PartyMakeup className={partyMakeup4Props.className}>{partyMakeup4Props.children}</PartyMakeup>
          <BeroreAfterGalleryOn>{beroreAfterGalleryOnProps.children}</BeroreAfterGalleryOn>
          <EditorialGallery className={editorialGalleryProps.className} />
        </div>
        <Group296 />
        <ViewMoreGallery />
      </div>
      <div className="group-306">
        <div className="group">
          <BridalGallery className={bridalGallery2Props.className} />
          <PartyMakeup className={partyMakeup5Props.className}>{partyMakeup5Props.children}</PartyMakeup>
          <BridalMakeup className={bridalMakeupProps.className}>{bridalMakeupProps.children}</BridalMakeup>
          <EditorialGalleryOn>{editorialGalleryOnProps.children}</EditorialGalleryOn>
        </div>
        <Group296 />
        <ViewMoreGallery className={viewMoreGalleryProps.className} />
      </div>
    </div>
  );
}

export default Property1Frame293;
